import React, { useCallback, useState, useEffect } from 'react';
import { Space, Table, Input, Button, Select } from 'antd';
import { useParams } from 'react-router-dom';
import { useRequest } from '../../../hooks';
import { getAlarms, getAlarmTypes } from '../../../api/onlineDatas';
import { dateTimeRender, textRender } from '../../../utils';
// import { alarmTypes } from '../../../constants';

const { Column } = Table;

const Alarms: React.FC<{
    showCertain?: {
        projectId: any, deviceSn: string
    }
}> = (props) => {
    const [alarmTypes, setAlarmTypes] = useState<any[]>([]);
    useEffect(() => {
        getAlarmTypes()
        .then(res => {
            setAlarmTypes(res.map(i => {
                return {
                    label: i.name, value: i.type
                }
            }))
        })
    }, [])
    const { projectId, deviceSn: deviceSnFromParams } = useParams();
    const [searchParams, setSearchParams] = useState<Partial<OnlineDataParams>>({
        projectId: projectId ? Number(projectId) : undefined,
        devSn: deviceSnFromParams,
    });
    const fetchData = useCallback(() => {
        if (props.showCertain) {
            return getAlarms(props.showCertain)
        }
        return getAlarms(searchParams)
    }, [searchParams, props.showCertain]);

    const { data, loading } = useRequest(fetchData);

    const [deviceSn, setDeviceSn] = useState(deviceSnFromParams);
    const [alarmType, setAlarmType] = useState<string>();

    return (
        <>
            {
                props.showCertain ? null :
                    <Space>
                        <Input placeholder='请输入设备序列号' onChange={e => setDeviceSn(e.target.value)} value={deviceSn} allowClear></Input>
                        <Select style={{width: 160}} placeholder="请选择告警类别" allowClear value={alarmType} onChange={e => setAlarmType(e)} options={alarmTypes} />
                        <Button type='primary' onClick={() => {
                            setSearchParams({
                                ...searchParams,
                                devSn: deviceSn,
                                alarmType,
                            })
                        }}>查询</Button>
                    </Space>
            }
            <br />
            <br />
            <AlarmTable data={data} loading={loading} />
        </>
    );
}

export const AlarmTable = (props:{data?: AlarmRecord[], loading?: boolean, pagination?: any}) => {
    return (
        <Table dataSource={props.data} loading={props.loading} pagination={props.pagination}>
        <Column title="设备序列号" dataIndex="deviceSn" key="deviceSn" />
        <Column title="开关号" render={textRender} dataIndex="switchNumber" key="switchNumber" />
        <Column title="网关" render={textRender} dataIndex="gatewayMac" key="gatewayMac" />
        <Column title="告警信息" dataIndex="description" key="description" />
        <Column title="接收时间" sorter dataIndex="receiveDatetime" key="receiveDatetime" render={time => {
            return dateTimeRender(time)
        }} />
    </Table>
    )
}

export default Alarms;